import { FC, useEffect, useState } from 'react';
import { Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import Swal from 'sweetalert2';
import { CargoManagementQuery } from '../../../../services/query';
import { MFCD, mfcdCls } from '../../mobileFieldCargoDistribution.classes';

interface IProps {
    selectedRow?: any;
    onClose?: any;
    companyList?: any;
    cityList?: any;
    listele?: any;
}
export const SCUIDrawerFilterMobileDistribution: FC<IProps> = ({
    selectedRow,
    onClose,
    cityList,
    companyList,
    listele,
}) => {
    const { t } = useTranslation();
    const serviceType = undefined;

    const [companyId, setCompanyId] = useState(1);
    const [cityId, setCityId] = useState<any>();
    const [countyId, setCountyId] = useState(0);
    const [countyList, setCountyList] = useState<any>([]);
    const [subCountyList, setSubCountyList] = useState<any>([]);
    const [subCountyId, setSubCountyId] = useState(0);
    const [countyName, setCountyName] = useState<any>('');
    const [subCountyName, setSubCountyName] = useState<any>('');
    const [cityName, setCityName] = useState<any>('');

    const GetCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityId: cityId,
                countryId: 1,
            };
            if (cityId !== 0) {
                CargoManagementQuery.SubAddressEntities(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setCountyList(parseData && [...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetSubCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityId: countyId,
                countryId: 1,
            };
            if (countyId !== 0) {
                CargoManagementQuery.SubAddressEntities(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setSubCountyList(parseData && [...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };

    useEffect(() => {
        GetCountyList();
    }, [cityId]);

    useEffect(() => {
        GetSubCountyList();
    }, [countyId]);

    const MobileCargoSearch = async () => {
        let mobileCargoDistribituon = {
            ShippingCompanyId: companyId,
            CityName: cityName.length > 0 ? cityName : null,
            CountyName: countyName.length > 0 ? countyName : null,
            NeighborhoodName: subCountyName.length > 0 ? subCountyName : null,
            ServiceDistributionTypeId: serviceType !== 0 ? serviceType : null,
        };
        listele(mobileCargoDistribituon);
    };

    return (
        <form
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className={mfcdCls('commentFilterContainer', MFCD.filterDrawerRoot)}>
                {
                    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <SCUIGeneralDrawerHeader header={'Detaylı Arama'} onClose={onClose} />
                        <Grid
                            sx= {{paddingLeft:0 }}
                            size={{
                                xs: 11,
                                md: 11,
                                lg: 11,
                                xl: 11
                            }}>
                            <Grid
                                className={MFCD.filterDrawerFieldCompany}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{t('cargoFeeManagement.selectCargoCompany')}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectFilterDrawerCompany}
                                    label={t('cargoFeeManagement.selectCargoCompany')}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={companyId}
                                    defaultValue={selectedRow?.shippingCompanyId}
                                    onChange={(event) => {
                                        setCompanyId(Number(event.target.value));
                                    }}
                                    fullWidth
                                >
                                    {companyList &&
                                        companyList
                                            .filter((comp: any) => comp.value !== '-1')
                                            .map((comp: any) => (
                                                <MenuItem key={comp.value} id={comp.value} value={comp.value}>
                                                    {comp.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.filterDrawerFieldCity}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{t('cargoManagement.selectCity')}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectFilterDrawerCity}
                                    label={t('cargoManagement.selectCity')}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={cityId}
                                    onChange={(event) => {
                                        setCityId(Number(event.target.value));
                                        setCityName(
                                            cityList.find((option: any) => option.value === event.target.value)?.text
                                        );

                                        console.info(Number(event.target.value));
                                    }}
                                    fullWidth
                                >
                                    {cityList &&
                                        cityList
                                            .filter((city: any) => city.value !== '-1')
                                            .map((city: any) => (
                                                <MenuItem key={city.value} id={city.value} value={city.value}>
                                                    {city.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.filterDrawerFieldCounty}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{'İlçe Seçiniz'}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectFilterDrawerCounty}
                                    label={'İlçe Seçiniz'}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={countyId}
                                    onChange={(event) => {
                                        setCountyId(Number(event.target.value));
                                        setCountyName(
                                            countyList.find((option: any) => option.value === event.target.value)?.text
                                        );
                                    }}
                                    fullWidth
                                >
                                    {countyList &&
                                        countyList
                                            .filter((county: any) => county.value !== '-1')
                                            .map((county: any) => (
                                                <MenuItem key={county.value} id={county.value} value={county.value}>
                                                    {county.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                            <Grid
                                className={MFCD.filterDrawerFieldNeighborhood}
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <InputLabel id="labelApp">{'Mahalle Seçiniz'}</InputLabel>
                                <Select
                                    className={MFCD.inputSelectFilterDrawerNeighborhood}
                                    label={'Mahalle Seçiniz'}
                                    labelId="labelApp"
                                    id="parentMenuLabel"
                                    value={subCountyId}
                                    onChange={(event) => {
                                        setSubCountyId(Number(event.target.value));
                                        setSubCountyName(
                                            subCountyList.find((option: any) => option.value === event.target.value)
                                                ?.text
                                        );
                                    }}
                                    fullWidth
                                >
                                    {subCountyList &&
                                        subCountyList
                                            .filter((subCounty: any) => subCounty.value !== '-1')
                                            .map((subCounty: any) => (
                                                <MenuItem
                                                    key={subCounty.value}
                                                    id={subCounty.value}
                                                    value={subCounty.value}
                                                >
                                                    {subCounty.text}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </Grid>
                        </Grid>
                        <div className={MFCD.filterDrawerActionsRow} style={{ display: 'flex', justifyContent: 'right' }}>
                        <SCUIButton
                                className={MFCD.inputButtonFilterDrawerSearch}
                                text={t('general.search')}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                style={{ width: '50%', marginTop: "10px", marginRight: "26px" }}
                                onClick={MobileCargoSearch}
                            />
                      </div>
                    </Grid>
                }
            </div>
        </form>
    );
};
